import React, { useState, useRef, useEffect } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { createPortal } from "react-dom";

const NmListHelpDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((s) => !s);
  const drawerContentRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (drawerContentRef.current && !drawerContentRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const drawer = (
    <div className="drawer-portal">
      <Drawer
        open={isOpen}
        onClose={toggle}
        direction="right"
        size={500}
        duration={400}
        overlayOpacity={0.5}
        overlayColor="#000"
        customIdSuffix="help-guide-nm-list"
        className="help-guide-drawer"
        style={{ top: "73px", height: "calc(100vh - 73px)", transition: "all 0.4s ease-in-out" }}
      >
        <div className="drawer-content" ref={drawerContentRef}>
  <div className="drawer-header">
    <div className="header-title">
      <span className="emoji">📋</span>
      <span className="title">Near Miss List Page – Help Guide</span>
    </div>
    <button className="close-button" onClick={toggle} aria-label="Close help panel">
      &times;
    </button>
  </div>

  <div className="drawer-body">
    <p>
      The Near Miss List Page displays all reported near misses and tracks their progress through
      three stages: <b>Pending</b>, <b>In-Progress</b>, and <b>Completed</b>. Each stage helps users
      and investigation teams monitor, investigate, and close near miss incidents efficiently.
    </p>

    <hr />
    <h5 className="section-title">📑 Tabs Overview</h5>

    <h5 className="section-title">🟡 Pending Tab</h5>
    <ul className="steps-list" style={{ listStyleType: "disc", paddingLeft: "20px" }}>
      <li>Displays all newly reported near misses (default status).</li>
      <li>Each record shows:</li>
      <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
        <li>NM Type</li>
        <li>Activity</li>
        <li>Service & Plant / Project / Client name</li>
        <li>Reported By</li>
        <li>Reported Date</li>
      </ul>
    </ul>

    <hr />
    <h5 className="section-title">🟠 In-Progress Tab</h5>
    <ul className="steps-list" style={{ listStyleType: "disc", paddingLeft: "20px" }}>
      <li>Shows near misses currently under investigation.</li>
      <li>Each record includes:</li>
      <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
        <li>NM Type</li>
        <li>Activity</li>
        <li>Overview by Days (Overdue = investigation not completed by due date)</li>
        <li>Service & Plant / Project / Client name</li>
        <li>Reported By</li>
        <li>Reported Date</li>
        <li>Investigation Team Members</li>
        <li>Investigation Team Lead</li>
        <li>Due Date to Complete Investigation</li>
      </ul>
    </ul>

    <hr />
    <h5 className="section-title">🟢 Completed Tab</h5>
    <ul className="steps-list" style={{ listStyleType: "disc", paddingLeft: "20px" }}>
      <li>Displays near misses where the investigation is finished.</li>
      <li>Each record shows:</li>
      <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
        <li>NM Type</li>
        <li>Activity</li>
        <li>Deviation (delay in completion beyond due date, shown in number of days)</li>
        <li>Service & Plant / Project / Client name</li>
        <li>Reported By</li>
        <li>Reported Date</li>
        <li>Investigation Team Members & Team Lead</li>
        <li>Due Date to Complete Investigation</li>
        <li>Closed Date (when investigation was completed)</li>
        <li>📄 PDF Icon – click to download the Near Miss Investigation Report</li>
      </ul>
    </ul>

    <hr />
    <h5 className="section-title">📤 Export Option</h5>
    <ul className="steps-list" style={{ listStyleType: "disc", paddingLeft: "20px" }}>
      <li>To download the entire Near Miss data, click the Excel icon located in the top-right corner.</li>
      <li>The file will be downloaded to your system’s default Downloads folder.</li>
    </ul>

        <hr />
    <div className="alert alert-info">
      <p>
        ⚡ <b>Tip:</b> The tab structure ensures clear tracking — from <b>Pending</b> (new reports) →
        <b> In-Progress</b> (active investigations) → <b>Completed</b> (closed cases), helping
        maintain accountability and timely resolution.
      </p>
    </div>
  </div>
</div>

      </Drawer>
    </div>
  );

  return (
    <>
      <div
        className="toggle-help-btn"
        onClick={toggle}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === "Enter" || e.key === " ") toggle();
        }}
        style={{ fontSize: "16px", cursor: "pointer" }}
      >
        Page Help
        <img src="/images/formkit_help.svg" alt="" />
      </div>
      {createPortal(drawer, document.body)}
    </>
  );
};

export default NmListHelpDrawer;
